import { getImage } from "gatsby-plugin-image"

import { WordpressApi } from "../helpers/WordpressApi"

import metadataFilters from "../components/config/SimpleBlogLatestFiltersCfg.json"

const _unique = arr => arr.filter((x, i, a) => a.indexOf(x) === i)

const loadFilters = classNames => {
  const filters = classNames.split(` `).reduce(
    (acc, curr) => {
      if (curr.startsWith(`icw-categories-`))
        acc.cats.push(curr.replace(`icw-categories-`, ``))

      if (curr.startsWith(`icw-tags-`))
        acc.cats.push(curr.replace(`icw-tags-`, ``))

      return acc
    },
    { cats: [], tags: [] }
  )

  filters.cats = _unique(filters.cats)
  filters.tags = _unique(filters.tags)

  return filters
}
const updateFilters = (prev, curr) => {
  return {
    cats: _unique([...prev.cats, ...curr.cats]),
    tags: _unique([...prev.tags, ...curr.tags]),
  }
}

const loadFilterOverrides = classNames => {
  let filters = classNames.split(` `).reduce((acc, curr) => {
    if (curr.startsWith(`icw-filter-override-`))
      acc.push(
        curr.replace(`icw-filter-override-`, ``).toLowerCase().replace(` `, `-`)
      )

    return acc
  }, [])

  filters = _unique(filters)

  return filters
}

const loadMetadataFilters = type => {
  return metadataFilters[type]
    .filter(f => f.kind === `category`)
    .map(f => f.label.toLowerCase().replace(` `, `-`))
}

const withFeaturedImage = posts => {
  return posts.map(p => {
    let featuredImage = null
    if (
      p.featuredImage &&
      p.featuredImage.node &&
      p.featuredImage.node.localFile
    )
      featuredImage = getImage(p.featuredImage.node.localFile)

    p.thumbnail = featuredImage

    return p
  })
}

const relevant = posts => {
  return withFeaturedImage(posts)
}

const realtimeRelevant = (posts, filters) => {
  if (!filters || (filters.cats.length === 0 && filters.tags.length === 0))
    return withFeaturedImage(posts)

  const lowerCaseFilters = [
    ...filters.cats
      .map(f => f.toLowerCase().replace(` `, `-`))
      .filter(f => f !== `cubewise_filters_subset`),
    ...filters.tags
      .map(f => f.toLowerCase().replace(` `, `-`))
      .filter(f => f !== `cubewise_filters_subset`),
  ]

  console.log(`lowerCaseFilters`, lowerCaseFilters)

  return withFeaturedImage(
    posts
      .filter(p => {
        return (
          p.tags.nodes.filter(t =>
            lowerCaseFilters.includes(t.name.toLowerCase())
          ).length > 0
        )
      })
      .concat(
        posts.filter(p => {
          return (
            p.categories.nodes.filter(t =>
              lowerCaseFilters.includes(t.name.toLowerCase())
            ).length > 0
          )
        })
      )
  )
}

const toGraphQLAlike = data => {
  return data.map(r => ({
    id: r.id,
    author: { node: { name: r.named_author || `` } },
    categories: { nodes: r.named_categories.map(c => ({ name: c })) },
    date: r.date || ``,
    excerpt: (r.excerpt && r.excerpt.rendered) || ``,
    slug: r.slug || ``,
    tags: { nodes: r.named_tags.map(c => ({ name: c })) },
    title: (r.title && r.title.rendered) || ``,
    uri: `/${r.slug}/`,
    fimg_url: r.fimg_url,
  }))
}

const fetchPosts = async (
  token,
  filters,
  categories,
  tags,
  wordpressUrl,
  pageNumber,
  pageArticles = 15
) => {
  if (!filters) return []

  const posts = await WordpressApi.getPosts(
    wordpressUrl,
    filters.cats.map(f => f.toLowerCase().replace(` `, `-`)),
    categories,
    filters.tags.map(f => f.toLowerCase().replace(` `, `-`)),
    tags,
    token,
    pageNumber,
    pageArticles
  )

  return {
    data: toGraphQLAlike(posts.data),
    currentPage: posts.currentPage,
    numberOfPages: posts.numberOfPages,
    numberOfPosts: posts.numberOfPosts,
  }
}

const fetchPostsAdvanced = async (
  token,
  filters,
  categories,
  tags,
  wordpressUrl,
  pageNumber,
  pageArticles = 15
) => {
  if (!filters) return []

  const productFilters = loadMetadataFilters(`Products`).map(f =>
    f.toLowerCase().replace(` `, `-`)
  )
  const contentTypeFilters = loadMetadataFilters(`Content Type`).map(f =>
    f.toLowerCase().replace(` `, `-`)
  )

  const sanitizedCats = filters.cats.map(f => f.toLowerCase().replace(` `, `-`))

  const activeProductFilters = productFilters.filter(v =>
    sanitizedCats.includes(v)
  )
  const activeContentTypeFilters = contentTypeFilters.filter(v =>
    sanitizedCats.includes(v)
  )

  if (
    activeProductFilters.length === 0 ||
    activeContentTypeFilters.length === 0
  )
    return fetchPosts(
      token,
      filters,
      categories,
      tags,
      wordpressUrl,
      pageNumber,
      pageArticles
    )

  console.log(
    `**************** productFilters & activeContentTypeFilters`,
    activeProductFilters,
    filters,
    contentTypeFilters,
    activeContentTypeFilters
  )

  const posts = await WordpressApi.getPostsAdvanced(
    wordpressUrl,
    activeProductFilters,
    activeContentTypeFilters,
    categories,
    token,
    pageNumber
  )

  return {
    data: toGraphQLAlike(posts.data),
    currentPage: posts.currentPage,
    numberOfPages: posts.numberOfPages,
    numberOfPosts: posts.numberOfPosts,
  }
}

const getCategoriesDictionary = async wordpressUrl =>
  WordpressApi.getCategoriesDictionary(wordpressUrl)

const getTagsDictionary = async wordpressUrl =>
  WordpressApi.getTagsDictionary(wordpressUrl)

const BlogHelpers = {
  unique: _unique,
  loadFilters: loadFilters,
  loadFilterOverrides: loadFilterOverrides,
  updateFilters: updateFilters,
  relevant: relevant,
  realtimeRelevant: realtimeRelevant,
  fetchPosts: fetchPosts,
  fetchPostsAdvanced: fetchPostsAdvanced,
  getCategoriesDictionary: getCategoriesDictionary,
  getTagsDictionary: getTagsDictionary,
  toGraphQLAlike: toGraphQLAlike,
}

export default BlogHelpers
